import { newAPI } from '../../../services';

export const fetchActivities = async url => {
  const response = await newAPI.get(url);
  return response.data;
}